var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 17C8.32052 18.3861 10.1844 19.25 12.25 19.25C16.2541 19.25 19.5 16.0041 19.5 12C19.5 7.99594 16.2541 4.75 12.25 4.75C9.31589 4.75 6.39102 6.72336 5.25 9.23039M5.25 9.23039H9.47688M5.25 9.23039V4.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/rotate-left.f18e3a867a9ce6859411c2ac9c8627b2.svg";
export { ForwardRef as ReactComponent };